import { Link } from 'react-router-dom';

const seoArticles = [
  {
    title: 'Complete Litbuy Spreadsheet Guide',
    excerpt: 'Everything you need to know about Litbuy Spreadsheet in 2026. Features, setup, comparisons, and expert strategies for e-commerce sellers.',
    path: '/litbuy-spreadsheet-guide',
    tag: 'Ultimate Guide',
    image: 'https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20a%20well%20organized%20spreadsheet%20with%20colorful%20charts%20and%20data%20tables%20on%20a%20clean%20desk%20with%20a%20notepad%20and%20pen%2C%20bright%20natural%20light%2C%20productive%20workspace%20photography&width=800&height=600&seq=article-v3-guide&orientation=landscape',
  },
  {
    title: 'Litbuy Spreadsheet for Beginners',
    excerpt: 'A step-by-step walkthrough for first-time users. Learn how to set up your first spreadsheet and start managing products in under 30 minutes.',
    path: '/litbuy-spreadsheet-beginners',
    tag: 'Beginner',
    image: 'https://readdy.ai/api/search-image?query=Person%20typing%20on%20a%20laptop%20with%20a%20friendly%20tutorial%20screen%20showing%20simple%20spreadsheet%20instructions%2C%20warm%20home%20environment%2C%20relaxed%20learning%20atmosphere%2C%20approachable%20educational%20photography&width=800&height=600&seq=article-v3-beginner&orientation=landscape',
  },
  {
    title: 'Litbuy Spreadsheet Features Explained',
    excerpt: 'Deep dive into every feature: product catalog management, sales tracking dashboard, automated calculations, and category organization tools.',
    path: '/litbuy-spreadsheet-features',
    tag: 'Features',
    image: 'https://readdy.ai/api/search-image?query=Closeup%20of%20a%20computer%20screen%20showing%20multiple%20spreadsheet%20features%20with%20colorful%20interface%20elements%2C%20modern%20UI%20design%2C%20clean%20tech%20photography%20with%20soft%20bokeh%20background&width=800&height=600&seq=article-v3-features&orientation=landscape',
  },
  {
    title: 'Best Litbuy Spreadsheet Templates',
    excerpt: 'Discover the most popular templates: inventory tracker, sales analytics, profit margin calculator, and product comparison sheets.',
    path: '/litbuy-spreadsheet-templates',
    tag: 'Templates',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20beautifully%20designed%20spreadsheet%20templates%20printed%20on%20paper%20spread%20across%20a%20wooden%20desk%2C%20organized%20and%20color%20coded%2C%20creative%20office%20supplies%20flat%20lay%20photography&width=800&height=600&seq=article-v3-templates&orientation=landscape',
  },
  {
    title: 'Litbuy Spreadsheet Pricing Guide',
    excerpt: 'Complete breakdown of Litbuy Spreadsheet pricing plans. Compare costs, features per tier, and find the best value for your business size.',
    path: '/litbuy-spreadsheet-pricing',
    tag: 'Pricing',
    image: 'https://readdy.ai/api/search-image?query=Modern%20pricing%20comparison%20table%20displayed%20on%20a%20tablet%20next%20to%20a%20coffee%20cup%20on%20a%20marble%20table%2C%20morning%20sunlight%2C%20clean%20financial%20planning%20aesthetic&width=800&height=600&seq=article-v3-pricing&orientation=landscape',
  },
  {
    title: 'Is Litbuy Spreadsheet Safe?',
    excerpt: 'Security analysis covering data protection, local storage options, privacy features, and best practices for keeping your business data secure.',
    path: '/litbuy-spreadsheet-safety',
    tag: 'Safety',
    image: 'https://readdy.ai/api/search-image?query=Padlock%20icon%20on%20a%20digital%20screen%20with%20shield%20symbol%2C%20data%20security%20concept%2C%20dark%20background%20with%20green%20accents%2C%20cybersecurity%20themed%20photography%20with%20circuit%20board%20elements&width=800&height=600&seq=article-v3-safety&orientation=landscape',
  },
  {
    title: 'Litbuy Spreadsheet Pros and Cons',
    excerpt: 'Honest assessment of strengths and limitations. See how Litbuy Spreadsheet compares on ease of use, features, and value for money.',
    path: '/litbuy-spreadsheet-pros-cons',
    tag: 'Review',
    image: 'https://readdy.ai/api/search-image?query=Balanced%20scale%20with%20checkmark%20and%20cross%20symbols%20on%20a%20light%20background%2C%20pros%20and%20cons%20concept%2C%20minimal%20clean%20illustrative%20style%2C%20decisionmaking%20visual%20metaphor&width=800&height=600&seq=article-v3-proscons&orientation=landscape',
  },
  {
    title: 'Best Alternatives to Litbuy Spreadsheet',
    excerpt: 'Compare Litbuy Spreadsheet with Excel, Google Sheets, Airtable, and Notion. Find the right tool for your specific e-commerce needs.',
    path: '/litbuy-spreadsheet-alternatives',
    tag: 'Comparison',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20different%20software%20icons%20and%20logos%20arranged%20in%20a%20comparison%20grid%20on%20a%20clean%20white%20background%2C%20product%20comparison%20concept%2C%20minimal%20tech%20flat%20lay%20photography&width=800&height=600&seq=article-v3-alternatives&orientation=landscape',
  },
  {
    title: 'Advanced Litbuy Spreadsheet Tips',
    excerpt: 'Power user strategies for conditional formatting, cross-channel data consolidation, custom formulas, and workflow automation.',
    path: '/litbuy-spreadsheet-advanced-tips',
    tag: 'Advanced',
    image: 'https://readdy.ai/api/search-image?query=Expert%20hands%20typing%20on%20a%20mechanical%20keyboard%20with%20complex%20spreadsheet%20formulas%20visible%20on%20a%20large%20monitor%2C%20dim%20ambient%20lighting%2C%20focused%20power%20user%20workspace%20photography&width=800&height=600&seq=article-v3-advanced&orientation=landscape',
  },
];

export default function ArticleTeasers() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="text-xs md:text-sm font-medium text-foreground-500 tracking-wider uppercase">SEO Guides</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
            Litbuy Spreadsheet
            <br />
            <span className="font-heading italic font-normal text-primary-500">Expert Articles</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-xl">
            In-depth guides, comparisons, and tutorials to help you master Litbuy Spreadsheet and grow your e-commerce business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group cursor-pointer bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 inline-block px-2.5 py-1 rounded-full bg-white/85 backdrop-blur-sm text-foreground-800 text-[11px] font-semibold">
                  {article.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-primary-500 font-medium">
                  Read Article <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}